import { useEffect, useState } from "react";
import { api } from "../api";

/**
 * Task L: 审批 nav badge — pending refund requests + pending discount approvals (the same lists the Approvals page
 * shows a manager). Polls every minute and whenever the page changes (e.g. after deciding a request).
 */
export function useApprovalsBadge(enabled: boolean, refreshKey = ""): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!enabled) { setN(0); return; }
    let stop = false;
    const tick = async () => {
      try {
        const [r, d] = await Promise.all([
          api<{ requests?: unknown[] }>("/api/refund-requests?status=requested"),
          api<{ approvals?: unknown[] }>("/api/discount-approvals"),
        ]);
        if (!stop) setN((r.requests?.length ?? 0) + (d.approvals?.length ?? 0));
      } catch { /* offline / no access: keep the last count */ }
    };
    void tick();
    const id = setInterval(() => void tick(), 60_000);
    return () => { stop = true; clearInterval(id); };
  }, [enabled, refreshKey]);
  return n;
}
